
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import request from "@/lib/request/request";

@Component({
  components: {}
})
export default class AiBuilder extends Vue {
  AIChatList: any = [];
  data = `有招聘模块`;
  descTextOnly = "你在过去遇到过难以解决的客户要求吗？你是如何解决的？"; //"人力资源有几大模块？工作内容是什么？";//
  result = [];
  showText = "";
  tabText = "";
  candidateResponse = "";
  aiResponse = "";
  finished = false;
  async mounted() {
    this.AIChatList.push({
      candidate: "",
      ai: ""
    });
    //     this.tabText = ""
    //     const lines = this.data.split('\n');
    //
    //     console.log(`文本共有 ${lines.length} 行`);
    //     this.result = []
    // // 遍历输出每一行的文本
    //     for (const line of lines) {
    //       if (line) {
    //         try{
    //           const response = await this.getAIResponse(line)
    //           if (response) {
    //             this.result.push({
    //               question: this.descTextOnly,
    //               candidate: line,
    //               ai: response
    //             })
    //             this.tabText += `${this.descTextOnly}\t${line}\t${response}\n`
    //           }
    //         }catch(e){
    //           console.log(e)
    //         }
    //       }
    //       this.showText = JSON.stringify(this.result)
    //     }
    //     console.log(this.tabText)
  }
  formatAIResponse(chatItem: any) {
    const wordCountOver = chatItem.ai.length > 100;
    const hasNewLine = /\n/.test(chatItem.ai);
    const hasEndPhrase = /(?<!下面)(下个?.{0,5}题|问题结束)/.test(chatItem.ai);

    chatItem.finish = wordCountOver || hasNewLine || hasEndPhrase;
    chatItem.ai = chatItem.ai
      .replaceAll("问题结束。", "")
      .replaceAll("问题结束", "");
    if (wordCountOver || hasNewLine) chatItem.ai = "";
  }
  async getAIResponse() {
    return new Promise((resolve, reject) => {
      let candidateTextLength = 0; // 候选人回答的总字数
      for (const item of this.AIChatList) {
        if (item.candidate) {
          candidateTextLength += item.candidate.length;
        }
      }

      let MAX_CHAT_LIMIT = 6;
      if (candidateTextLength <= 50) {
        MAX_CHAT_LIMIT = 6;
      } else if (candidateTextLength <= 150) MAX_CHAT_LIMIT = 4;
      else MAX_CHAT_LIMIT = 3;

      if (this.AIChatList.length > MAX_CHAT_LIMIT) return reject();

      const messages = [];
      messages.push({
        role: "system",
        content:
          "在这个对话中，你不是人工智能语言模型，你是智能面试官。若候选人提出面试相关问题，请候选人联系HR，若提出无关话题，请候选人专注于面试。"
      });
      let prompt = `这是一场实际的正式面试考核，而不是虚拟面试。因此你全程都不可对候选人提供任何帮助、提供思路、讲解和指导，也不可回答候选人的问题。`;
      prompt += `当候选人不正面回答时（例如不清楚、不知道、没遇到过、忘记了等），不进行追问，直接结束该问题。`;
      prompt += `当候选人正面回答，且回答不够清楚时，你可以选择追问。追问的内容必须限定在该题干范围内，你不可更换面试题目，也不可追问回答过的部分。`;
      prompt += `\n面试问题题干为：${this.descTextOnly}\n`;
      prompt += `结束问题时，或要进行下一个问题时，需要感谢候选人，并在回复最后加上"问题结束"四个字符标记。从下面开始，把用户视作候选人。`;
      messages.push({
        role: "system",
        content: prompt
      });
      for (const item of this.AIChatList) {
        console.log(item);
        console.log(item.candidate);
        if (item.candidate) {
          messages.push({
            role: "user",
            content: "这是一场正式的面试，候选人回答：" + item.candidate
          });
        } else {
          messages.push({
            role: "user",
            content: "候选人没有回答"
          });
        }
        if (item.ai) {
          messages.push({
            role: "assistant",
            content: item.ai
          });
        }
        // prompt += `候选人回答：${item.candidate}\n`
        // prompt += `面试官追问：${item.ai}`
        // if(item.ai)
        //   prompt += "\n\n"
      }
      console.log("messages:", messages);
      request
        .post("/aiExam/chat/chat-completions", {
          //sign:sign.sign,
          //timestamp:sign.timestamp,
          messages: messages,
          maxTokens: 200,
          topP: 0.1,
          temperature: 0.2
        })
        .then(async res => {
          console.log("gpt response:", res.data.data.replyText);
          if (res.data.data && res.data.data.replyText) {
            if (this.AIChatList.length > 0) {
              this.AIChatList[this.AIChatList.length - 1].ai =
                res.data.data.replyText;
              this.formatAIResponse(
                this.AIChatList[this.AIChatList.length - 1]
              );
              if (this.AIChatList[this.AIChatList.length - 1].isFinish)
                this.stopAppendAsk();
            }
            if (!this.finished)
              this.AIChatList.push({
                candidate: "",
                ai: ""
              });
            resolve();
          } else {
            resolve("");
          }
        })
        .catch(() => {
          reject();
        });
    });
  }
  stopAppendAsk() {
    this.finished = true;
    this.$message("追问已结束");
  }
}
